import { ApiError } from '../client';

/**
 * Normalise a list response to an array so components never crash on an unexpected shape.
 *  - null / empty body            -> []
 *  - a bare array                 -> as is
 *  - an object wrapping the list  -> raw[key]   (e.g. GET /countries returns { countries: [...] })
 * Anything else is reported as an error (shown by the UI's error state) instead of being guessed at.
 */
export function asList(raw, key) {
  if (raw === null || raw === undefined) return [];
  if (Array.isArray(raw)) return raw;
  if (key && raw && Array.isArray(raw[key])) return raw[key];
  throw new ApiError('The server returned data in an unexpected format.', { kind: 'parse' });
}
